import React from 'react';
import {Link} from 'react-router';
import { I18n, Trans } from 'react-i18next';

export class FooterItems extends React.Component {
  render() {
   
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
             <div className="col-md-7 col-sm-7 col-xs-12 ">
                    <ul id="footer-blog">
                      <li><a href="#">{t('footeritem')}</a> </li>
                      <li><Link to="propos">{t('footeritem1')}</Link></li> 
                      <li><Link to="pros">{t('footeritem2')}</Link></li> 
                      <li className="hidden-xs"><a href="mailto:contact@hapiwine.fr">contact@hapiwine.fr</a> </li>
                    </ul>
              </div>
           )
        }
      </I18n>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Footer/FooterItems/FooterItems.js